import React from "react";
import Skills from "./Skills";
import aboutimg from "../images/hero_bg.jpeg";

function About() {
  return (
    <div>
      <section id="about" className="about">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>About</h2>
            <p>
Software Engineer with strong DevOps expertise, experienced in designing and building robust REST-APIs, managing databases, and working across networking, automation, and cloud infrastructure. Proficient in AWS and Azure, with hands-on experience deploying and operating containerized, cloud-native systems using Docker, Kubernetes, and GitOps practices. <br></br>

Skilled in infrastructure automation and CI/CD pipeline design using tools such as Terraform, Ansible, and GitHub Actions. Adept at building reliable, scalable systems, improving release workflows, and supporting high-availability platforms through effective monitoring and operational best practices. Passionate about bridging development and operations to enable fast, secure, and resilient software delivery.
            </p>

          </div>
          <div className="row">
            <div className="col-lg-4">
              <img src={aboutimg} className="img-fluid" alt="devriz" />
            </div>
            <div className="col-lg-8 pt-4 pt-lg-0 content">
              <h3>Software Engineer &amp; DEVOPS Enthusiast</h3>
              <p className="font-italic">
                Below is a small biograph of myself. I can describe myself as
                young, competent and energetic person who is ready to learn and
                adapt to changes in the industry
              </p>
              <div className="row">
                <div className="col-lg-6">
                  <ul>
                    <li>
                      <i className="icofont-rounded-right" />{" "}
                      <strong>Name : </strong> Eric Mwakazi
                    </li>
                    <li>
                      <i className="icofont-rounded-right" />{" "}
                      <strong>Website : </strong>
                      <a href=" https://mwakazieric.vercel.app" target="_blank">
                      https://mwakazieric.vercel.app
                      </a>
                    </li>
                    <li>
                      <i className="icofont-rounded-right" />{" "}
                      <strong>Phone :</strong> +254706570456
                    </li>
                    <li>
                      <i className="icofont-rounded-right" />{" "}
                      <strong>City : </strong>Nairobi, KENYA
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul>
                    <li>
                      <i className="icofont-rounded-right" />{" "}
                      <strong>Nationality :</strong> Kenyan
                    </li>

                    <li>
                      <i className="icofont-rounded-right" />{" "}
                      <strong>Email : </strong> mwakazieric@gmail.com
                    </li>
                    <li>
                      <i className="icofont-rounded-right" />{" "}
                      <strong>github : </strong>{" "}
                      <a
                        href="https://github.com/hamisirizwan"
                        target="_blank"
                        rel="noreferrer"
                      >
                        https://github.com/eric-mwakazi
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Skills />
    </div>
  );
}

export default About;
